import React from 'react';
import {translations} from '../translations';

const Footer = ({ language }) => {
    const footerColumns = [
        {
            titleKey: 'footer.company',
            content: (
                <>
                    <p className="chinese-font">{translations[language]['footer.description']}</p>
                    <div className="social-links">
                        {/*<a href="#"><FaLinkedin /></a>*/}
                        {/*<a href="#"><FaTwitter /></a>*/}
                        {/*<a href="#"><FaFacebook /></a>*/}
                        {/*<a href="#"><FaYoutube /></a>*/}
                    </div>
                </>
            )
        },
        {
            titleKey: 'footer.product',
            links: [
                { key: 'nav.features', href: '#features' },
                { key: 'footer.integrations', href: '#integrations' },
                { key: 'nav.pricing', href: '#pricing' },
                { key: 'footer.updates', href: '#updates' },
                { key: 'footer.roadmap', href: '#roadmap' }
            ]
        },
        {
            titleKey: 'footer.resources',
            links: [
                { key: 'footer.blog', href: '#blog' },
                { key: 'footer.guides', href: '#guides' },
                { key: 'footer.webinars', href: '#webinars' },
                { key: 'footer.help', href: '#help' },
                { key: 'footer.api', href: '#api' }
            ]
        },
        {
            titleKey: 'footer.companyMenu',
            links: [
                { key: 'footer.about', href: '#about' },
                { key: 'footer.careers', href: '#careers' },
                { key: 'footer.partners', href: '#partners' },
                { key: 'nav.contact', href: '#contact' },
                { key: 'footer.press', href: '#press' }
            ]
        }
    ];

    return (
        <footer id="contact">
            <div className="footer-content">
                {footerColumns.map((column, index) => (
                    <div className="footer-column" key={index}>
                        <h4 className="chinese-font">{translations[language][column.titleKey]}</h4>
                        {column.content ? (
                            column.content
                        ) : (
                            <ul className="footer-links">
                                {column.links.map((link, idx) => (
                                    <li key={idx}>
                                        <a href={link.href}>{translations[language][link.key]}</a>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                ))}
            </div>
            <div className="footer-bottom">
                <p className="chinese-font">
                    &copy; {translations[language]['footer.copyright']} |
                    <a href="#privacy"> {translations[language]['footer.privacy']}</a> |
                    <a href="#terms"> {translations[language]['footer.terms']}</a>
                </p>
            </div>
        </footer>
    );
};

export default Footer;
